const NAMESPACE = "route-query:";

export default {
  mounted() { },
  methods: {
    _saveQuery(data) {
      sessionStorage[NAMESPACE + this.$route.name] = JSON.stringify(data);
    },
    _loadQuery(routeName = null) {
      routeName = routeName || this.$route.name;

      const queryData = sessionStorage[NAMESPACE + routeName];
      if (queryData) {
        return JSON.parse(queryData);
      }
    }
  }
};
